import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { LocalStorageService } from '../../services/localstorageService.service';


export const ConfirmGuard: CanActivateFn | CanMatchFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {
    const localStorageService = inject(LocalStorageService);
    const router = inject(Router);

    const returnToken = route.queryParamMap.get('returnToken');    
    
    if (returnToken) {
      localStorageService.saveToken("homai_token", returnToken);
      localStorageService.registerCompleted.next(true);
      router.navigate(['/home']);
      return false; 
    }

    return true; 
};